function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "pixel-this-clothing-/-icons-/-bomb---dark",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(5.929124, 10.082594) rotate(-360.000000) translate(-5.929124, -10.082594) translate(-1.070876, 3.082594)",
  stroke: "#363636"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  strokeWidth: 2,
  transform: "translate(7.001293, 7.001293) rotate(-315.000000) translate(-7.001293, -7.001293) ",
  cx: 7.00129307,
  cy: 7.00129307,
  r: 4.91131572
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.34884066,5.90261131 C4.34884066,7.11618167 5.33263382,8.09997483 6.54620418,8.09997483",
  id: "Path",
  strokeLinecap: "round",
  transform: "translate(5.447522, 7.001293) rotate(-315.000000) translate(-5.447522, -7.001293) "
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.709582,
  y1: 3.29300416,
  x2: 12.2892565,
  y2: 1.71332967,
  id: "Path-25",
  strokeWidth: 2,
  strokeLinecap: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(13.379217, 2.708400) rotate(-315.000000) translate(-13.379217, -2.708400) translate(11.879217, 0.708400)",
  stroke: "#363636",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("line", {
  x1: 2.81633576,
  y1: 0.285271491,
  x2: 0.0852590572,
  y2: 3.0163482,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.0852590572,
  y1: 0.285271491,
  x2: 2.81633576,
  y2: 3.0163482,
  id: "Path"
})));

function SvgBomb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pixel this clothing / icons / bomb - dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBomb);
export default __webpack_public_path__ + "static/media/bomb.075418a0.svg";
export { ForwardRef as ReactComponent };